import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";

const PageSentry = ({ children }) => {
  const path = window.location.pathname;
  const navigate = useNavigate();
  useEffect(() => {
    ErrorToast("Page not found!");
    navigate("/");
  }, []);

  return <></>;
};

export default PageSentry;
